<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row :gutter="20">
			<el-col :span="24" :xs="24">
				<el-card class="box-card">
					<div slot="header" class="clearfix header">
						<el-col :span="12" :xs="12"><span>网站基本信息</span></el-col>
						<el-col :span="12" :xs="12"><el-button @click="handleUpdate" type="primary" size="mini" icon="el-icon-edit">修改</el-button></el-col>
					</div>
					<div style="margin-top: 20px;">
						<ul class="list-group list-group-striped">
							<li class="list-group-item">
								<div>标题</div>
								<div class="pull-right">{{ baseInfo.title }}</div>
							</li>
							<li class="list-group-item">
								<div>关键词</div>
								<div class="pull-right">{{ baseInfo.keyword }}</div>
							</li>
							<li class="list-group-item">
								<div>单位名称</div>

								<div class="pull-right">{{ baseInfo.organName }}</div>
							</li>
							<li class="list-group-item">
								<div>电话</div>

								<div class="pull-right">{{ baseInfo.phone }}</div>
							</li>
							<li class="list-group-item">
								<div>传真</div>
								<div class="pull-right">{{ baseInfo.fax }}</div>
							</li>
							<li class="list-group-item">
								<div>邮编</div>
								<div class="pull-right">{{ baseInfo.zipCode }}</div>
							</li>
							<li class="list-group-item">
								<div>备案号</div>

								<div class="pull-right">{{ baseInfo.internetContentProvider }}</div>
							</li>

							<li class="list-group-item">
								<div>京公网安备案号</div>

								<div class="pull-right">{{ baseInfo.jingNetworkSecurityNumber }}</div>
							</li>
							<li class="list-group-item">
								<div>描述信息</div>

								<div class="pull-right">{{ baseInfo.description }}</div>
							</li>
							<li class="list-group-item">
								<div>悬浮开关</div>

								<div class="pull-right"><el-switch v-model="baseInfo.suspend" active-value="1" inactive-value="0" disabled></el-switch></div>
							</li>
						</ul>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<Edit :open="open" :form="form" @submitForm="submitForm" @cancel="cancel" />
	</el-card>
</template>
<script>
import Edit from './baseInfo-edit.vue';
export default {
	components: {
		Edit
	},
	data() {
		return {
			baseInfo: {},
			open: false,
			form: {}
		};
	},
	created() {
		this.getDetails();
	},
	methods: {
		getDetails() {
			this.$http
				.get('/sys/params/webBaseInfo')
				.then(res => {
					this.baseInfo = res.data.data;
					let data=JSON.stringify(res.data.data);
					this.form=JSON.parse(data)
					
				})
				.catch(err => {});
		},
		handleUpdate() {
			this.open = true;
		},
		submitForm(){
			this.getDetails();
			this.cancel();
		},
		cancel(){
			this.open = false;
		}
	}
};
</script>
<style scoped>
.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.header span {
	font-size: 16px;
	font-weight: bold;
}
.header button {
	float: right;
}
.list-group-striped > .list-group-item {
	border-left: 0;
	border-right: 0;
	border-radius: 0;
	padding-left: 0;
	padding-right: 0;
}

.list-group {
	padding-left: 0px;
	list-style: none;
}

.list-group-item {
	border-bottom: 1px solid #e7eaec;
	margin-bottom: -1px;
	padding: 15px 0;
	font-size: 13px;
	display: flex;
	justify-content: space-between;
}
.list-group-item :first-child {
	font-size: 15px;
}
.pull-right {
	float: right !important;
}
</style>
